import React, { PropsWithChildren } from 'react'
import { twMerge } from 'tailwind-merge'

const TemplatesCategoryItem = ({
  isSelected,
  children,
  onClick,
}: PropsWithChildren<{ isSelected: boolean; onClick: () => void }>) => {
  return (
    <button
      onClick={onClick}
      className={twMerge(
        'main-transition-colors flex w-full justify-start whitespace-nowrap rounded-lg px-5 py-2.5 outline-none ring-brand-primary ring-offset-2 focus-visible:ring-2',
        isSelected
          ? 'bg-brand-primary text-background-secondary'
          : 'text-text-primary hover:text-brand-primary',
      )}
    >
      {children}
    </button>
  )
}

export default TemplatesCategoryItem
